import { ModalActionTypes } from '@acorns/web-components'

import trackEvent from 'utils/analytics/trackEvent'

const investorQuestionConfirmationModal = (title, message) => {
  trackEvent('Container Viewed', {
    eventData: {
      object_name: 'registration.investorQuestionConfirmation',
      type: 'container_viewed',
      screen: title,
    },
  })

  return {
    title,
    message,
    actions: [
      {
        type: ModalActionTypes.primary,
        label: 'Yes',
      },
      {
        type: ModalActionTypes.secondary,
        label: 'No',
      },
    ],
  }
}

const eventData = {
  object_name: 'registration.error',
  type: 'container_viewed',
  event_text: 'Container View',
  screen: investorQuestionsConfirmation,
  title: '',
}

export const brokerDealerConfirmation = async (promptUser, value) => {
  let confirmed = true

  if (value) {
    const title = 'Confirm broker dealer affiliation'
    const message =
      'Most investors answer “No,” so we want to be double check that you’re affiliated with a broker dealer.'

    trackEvent('Container Viewed', { ...eventData, title })
    await promptUser(investorQuestionConfirmationModal(title, message)).then(result => {
      if (result.index === 1) {
        confirmed = false
      }
    })
  }
  return confirmed
}

export const shareHolderConfirmation = async (promptUser, value) => {
  let confirmed = true
  if (value) {
    const title = 'Confirm that you are a shareholder'
    const message =
      'Most investors answer “No,” so we want to double check. Are you sure that you are a 10% shareholder or director of a publicly traded company?'

    trackEvent('Container Viewed', { ...eventData, title })
    await promptUser(investorQuestionConfirmationModal(title, message)).then(result => {
      if (result.index === 1) {
        confirmed = false
      }
    })
  }
  return confirmed
}

export const backupWithholdingConfirmation = async (promptUser, value) => {
  let confirmed = true

  if (value) {
    const title = 'Confirm backup withholding'
    const message =
      'Most investors answer “No,” so we want to double check. Has the IRS notified you that you are subject to backup withholding?'

    trackEvent('Container Viewed', { ...eventData, title })
    await promptUser(investorQuestionConfirmationModal(title, message)).then(result => {
      if (result.index === 1) {
        confirmed = false
      }
    })
  }
  return confirmed
}

export const investorQuestionsConfirmation = async (promptUser, values) => {
  const brokerDealerConf = await brokerDealerConfirmation(
    promptUser,
    values.employedAffiliatedWithBrokerDealer,
  )
  if (!brokerDealerConf) {
    return false
  }

  const shareHolderConf = await shareHolderConfirmation(promptUser, values.shareholderOrDirector)
  if (!shareHolderConf) {
    return false
  }

  const backupWitholdConf = await backupWithholdingConfirmation(
    promptUser,
    values.subjectToBackupWithholding,
  )
  if (!backupWitholdConf) {
    return false
  }

  return true
}
